export default __webpack_public_path__ + "static/media/temperature.4a0e88cd.svg";